import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

// --- ARTIK RİSK YOK: ADRESİ SABİTLİYORUZ ---
// Bu sayfa dünyanın neresinden açılırsa açılsın,
// direkt olarak senin canlı sunucuna bağlanacak.
const API = "https://mertt.tr/api";

// Resim URL'lerini de canlı sunucuya sabitliyoruz
const getImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  
  // Resim yolunun başında / var mı yok mu kontrol et
  const cleanPath = url.startsWith('/') ? url : `/${url}`;
  
  // Sonuç: https://mertt.tr/uploads/resim.jpg
  return `https://mertt.tr${cleanPath}`;
};

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language } = useLanguage();

  useEffect(() => {
    // Konsola yazdıralım ki çalıştığını gör
    console.log("Bağlanılan Adres (ZORLAMA):", `${API}/services`);

    fetch(`${API}/services`)
      .then(res => {
        if (!res.ok) throw new Error('Sunucu cevap vermedi');
        return res.json();
      })
      .then(data => {
        // Backend bazen {data: []} bazen direkt [] gönderir.
        // İkisini de garantiye alıyoruz:
        if (Array.isArray(data)) {
            setServices(data);
        } else if (data && Array.isArray(data.data)) {
            setServices(data.data);
        } else {
            setServices([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Bağlantı Hatası:", err);
        setLoading(false);
      });
      
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />

      <div className="pt-32 px-6 pb-20">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-12 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
             {language === 'tr' ? 'Hizmetlerimiz' : 'Our Services'}
          </h1>
          
          {loading ? (
             <div className="text-center py-20 flex flex-col items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
                <p className="text-gray-400">Canlı sunucudan veriler alınıyor...</p>
             </div>
          ) : services.length === 0 ? (
             <div className="text-center py-20 text-gray-500 border border-gray-800 rounded-xl bg-gray-900/50">
                <p>Sunucuya erişildi ama hizmet listesi boş.</p>
                <p className="text-xs mt-2 text-gray-600">Lütfen https://mertt.tr/admin adresinden veri eklediğine emin ol.</p>
             </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <motion.div
                  key={service.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 hover:border-blue-500/50 transition group flex flex-col h-full shadow-lg"
                >
                  <div className="h-48 overflow-hidden relative bg-gray-800">
                    <img 
                        src={getImageUrl(service.image_url)} 
                        alt={language === 'tr' ? service.title_tr : service.title_en}
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-500" 
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://via.placeholder.com/400x300?text=Resim+Yok';
                        }}
                    />
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition"></div>
                  </div>
                  
                  <div className="p-6 flex flex-col flex-grow">
                    <h3 className="text-xl font-bold mb-3 text-white group-hover:text-blue-400 transition">
                      {language === 'tr' ? service.title_tr : service.title_en}
                    </h3>
                    <p className="text-gray-400 mb-6 line-clamp-3 flex-grow text-sm leading-relaxed">
                      {language === 'tr' ? service.description_tr : service.description_en}
                    </p>
                    <Link 
                      to={`/services/${service.id}`}
                      className="mt-auto w-full bg-gray-800 hover:bg-blue-600 text-white py-3 rounded-xl text-center font-semibold transition border border-gray-700 hover:border-blue-500"
                    >
                      {language === 'tr' ? 'İncele' : 'View Details'}
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;